export default __webpack_public_path__ + "static/media/map-marker.b2987e34.svg";